<template>
    <div>
        <az-break-title title="Regra de Cirurgia (Redução)" />

        <div>

            <div class="row mb-3">
                <div class="col col-12 col-md-9">
                    <az-input icon="fas fa-search" v-model="search"></az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state icon="fa-solid fa-badge-percent" msg="Nenhuma regra identificada." 
                :action="!search ? 'Incluir Regra' : ''" :method="incluir" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item" v-for="(dado, id) in lista" :key="id">
                    <div class="d-flex justify-content-between">
                        <span>
                            <a href="#" @click.prevent="editar(dado)" class="card-link">
                                {{ dado.search }}
                            </a>
                        </span>
                        <span>
                            <a href="#" @click.prevent="remover(dado)" class="card-link text-danger">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </a>
                        </span>
                    </div>
                </li>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="cadastroModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Regra de Cirurgia (Redução)
                            {{ item.id_operadora_regra_cirurgia ? '#' + item.id_operadora_regra_cirurgia : '(Nova)' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Título"
                                    placeholder="Informar..."
                                    v-model="item.st_titulo"
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Via"
                                    type="select" 
                                    :optionsList="[
                                        { id: 'M', search: 'Mesma Via' }, 
                                        { id: 'D', search: 'Via Diferente' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_via" 
                                    required
                                    :validate="validate" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Percentual"
                                    required
                                    :validate="validate"
                                    type="number"
                                    v-model="item.dc_percentual" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Procedimento Inicial"
                                    required
                                    :validate="validate"
                                    type="number"
                                    v-model="item.in_qt_inicio" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Procedimento Final"
                                    required
                                    :validate="validate"
                                    type="number"
                                    v-model="item.in_qt_fim" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="operadoraRegraCirurgia" :id="item.id_operadora_regra_cirurgia" v-if="item && item.id_operadora_regra_cirurgia" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_operadora_regra_cirurgia ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzBreakTitle from '../../../util/AzBreakTitle.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import FiltroModel from '../../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            search: "",
            item: null,  
            validate: false, 
            viewMode: "A",
        }
    },

    components: { 
        AzBreakTitle,
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel, 
    }, 

    props: ['id_operadora'],

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return !this.search || reg.test(JSON.stringify(item));
                }) : null ; 
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
            ];

            /*
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\recepcao', search:'Recepção', service:'recepcaos.index', parms: { filtros: true }},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];
            */

            return opcoes;
        },
    },

    methods: { 
        remover (item) { 

            if ( !confirm('Confirma remover a regra "' + item.search + '"?') ) { 
                return; 
            }

            this.$util.remover (this, { 
                service: 'operadora_regra_cirurgias',
                dados: item,
                reload: true, 
                modal: 'cadastroModal',
            });

        },

        incluir () { 
            this.validate = false;
            
            this.item = { 
                id_operadora: this.id_operadora,
                st_via: "",
                dc_percentual: null, 
                in_qt_inicio: null,
                in_qt_fim: null,
            }

            $('#cadastroModal').modal('show');

        },

        editar (item) { 

            this.validate = false;
            this.item = { ...item };

            $('#cadastroModal').modal('show');

        },

        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'operadora_regra_cirurgias',
                dados: this.item,
                reload: true, 
                modal: 'cadastroModal',
            });

        },

        load () { 
            this.$util.load(this, { 
                service: 'operadora_regra_cirurgias',
                func: 'index',
                parms: { 
                    id_operadora: this.id_operadora,
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    },

    mounted () { 
        this.load (); 
    }
}
</script>